<main>
  <section
    class="relative pt-32 pb-20 lg:pt-48 lg:pb-20 text-center lg:text-left overflow-hidden gradient-bg-hero"
  >
    <div
      class="container mx-auto px-6 relative z-10 flex flex-col lg:flex-row items-center justify-between"
      *ngIf="product"
    >
      <div class="lg:w-1/2 mb-1 lg:mb-0">
        <!-- <p class="text-secondary text-lg mb-4">Product Overview</p> -->
        <h1
          class="text-4xl lg:text-5xl font-extrabold leading-tight bg-gradient-to-r from-white via-[#336799] to-blue-900 bg-clip-text text-transparent"
        >
          {{ product.heading }}
          {{ product.highlight }}
        </h1>
        <p
          class="text-lg lg:text-xl max-w-3xl lg:max-w-none my-5 text-zinc-400 opacity-90"
        >
          {{ product.description }}
        </p>
        <button
          (click)="showModal = true"
          class="w-100 btn-primary px-8 py-3 my-4 rounded-full text-lg font-medium"
        >
          Register your estate
        </button>
        <div
          class="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4"
        >
          <!-- From Uiverse.io by Yaya12085 -->
          <a
            href="https://play.google.com/store/apps/details?id=com.echobitstech.estate360&pcampaignid=web_share"
            class="playstore-button"
          >
            <span class="icon">
              <svg
                fill="currentColor"
                viewBox="-52.01 0 560.035 560.035"
                xmlns="http://www.w3.org/2000/svg"
                stroke="#ffffff"
              >
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g
                  id="SVGRepo_tracerCarrier"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></g>
                <g id="SVGRepo_iconCarrier">
                  <path
                    d="M380.844 297.529c.787 84.752 74.349 112.955 75.164 113.314-.622 1.988-11.754 40.191-38.756 79.652-23.343 34.117-47.568 68.107-85.731 68.811-37.499.691-49.557-22.236-92.429-22.236-42.859 0-56.256 21.533-91.753 22.928-36.837 1.395-64.889-36.891-88.424-70.883-48.093-69.53-84.846-196.475-35.496-282.165 24.516-42.554 68.328-69.501 115.882-70.192 36.173-.69 70.315 24.336 92.429 24.336 22.1 0 63.59-30.096 107.208-25.676 18.26.76 69.517 7.376 102.429 55.552-2.652 1.644-61.159 35.704-60.523 106.559M310.369 89.418C329.926 65.745 343.089 32.79 339.498 0 311.308 1.133 277.22 18.785 257 42.445c-18.121 20.952-33.991 54.487-29.709 86.628 31.421 2.431 63.52-15.967 83.078-39.655"
                  ></path>
                </g>
              </svg>
            </span>
            <span class="texts">
              <span class="text-1">Download form</span>
              <span class="text-2">App store</span>
            </span>
          </a>

          <!-- From Uiverse.io by DhogMiT10 -->
          <a
            href="https://apps.apple.com/ng/app/estate360-resident/id6745845018"
            class="playstore-button"
          >
            <svg
              viewBox="0 0 512 512"
              class="icon"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M99.617 8.057a50.191 50.191 0 00-38.815-6.713l230.932 230.933 74.846-74.846L99.617 8.057zM32.139 20.116c-6.441 8.563-10.148 19.077-10.148 30.199v411.358c0 11.123 3.708 21.636 10.148 30.199l235.877-235.877L32.139 20.116zM464.261 212.087l-67.266-37.637-81.544 81.544 81.548 81.548 67.273-37.64c16.117-9.03 25.738-25.442 25.738-43.908s-9.621-34.877-25.749-43.907zM291.733 279.711L60.815 510.629c3.786.891 7.639 1.371 11.492 1.371a50.275 50.275 0 0027.31-8.07l266.965-149.372-74.849-74.847z"
              ></path>
            </svg>
            <span class="texts">
              <span class="text-1">GET IT ON</span>
              <span class="text-2">Google Play</span>
            </span>
          </a>
        </div>
      </div>

      <div class="lg:w-1/2 flex justify-center lg:justify-end max-sm:pt-5">
        <img
          [src]="product.image"
          [alt]="product.title"
          class="rounded-xl shadow-2xl w-full max-w-lg h-auto object-cover"
        />
      </div>
    </div>

    <!-- <div
      class="container mx-auto px-6 relative z-10 flex flex-col lg:flex-row items-center justify-between"
    >
      <div class="lg:w-1/2 mb-1 lg:mb-0">
        <p class="text-secondary text-lg mb-4">Product Overview</p>
        <h1
          class="text-4xl lg:text-6xl font-extrabold leading-tight text-blue-400"
        >
          Developer-friendly <br /><span class="text-accent-blue"
            >Access Management</span
          >
        </h1>
        <p
          class="text-lg lg:text-xl max-w-3xl lg:max-w-none mb-5 text-zinc-600 opacity-90"
        >
          Empower your estate with seamless resident, security, and manager
          coordination. Estate360 Community simplifies access control, emergency
          response, and service requests in one smart platform.
        </p>
        <div
          class="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4"
        >
          <button
            class="btn-primary px-8 py-3 rounded-full text-lg font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
          >
            Get Started
          </button>
          <button
            class="btn-secondary border-2 px-8 py-3 rounded-full text-lg font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
          >
            Contact Sales
          </button>
        </div>
      </div>
      <div class="lg:w-1/2 flex justify-center lg:justify-end">
        <img
          src="https://placehold.co/700x450/1A1A1A/F2F2F7?text=Product+UI+Mockup"
          alt="Product UI Mockup"
          class="rounded-xl shadow-2xl w-full max-w-lg h-auto object-cover border border-border-color"
        />
      </div>
    </div> -->
  </section>

  <!-- Key Features Refatored begins -->
  <section id="features" class="py-20 lg:py-10 bg-secondary">
    <div class="container mx-auto px-6">
      <h2 class="text-4xl md:text-5xl font-bold text-center mb-16 text-primary">
        Key Features
      </h2>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:gap-12">
        <div class="p-8 rounded-xl flex flex-col items-center text-center">
          <div
            class="w-24 h-24 mb-6 flex items-center justify-center rounded-full bg-accent-blue/10"
          >
            <img
              src="https://placehold.co/200x150/336799/FFFFFF?text=Feature+A+Icon"
              alt="Feature A Icon"
              class="rounded-lg w-full h-auto object-cover border border-border-color"
            />
          </div>
          <h3 class="text-2xl font-bold mb-3 text-primary">
            Role-Based Access Control (RBAC)s
          </h3>
          <p class="text-secondary opacity-80">
            Assign different access levels to residents, managers, and security
            staff. Ensure only authorized individuals manage estate features.
          </p>
        </div>
        <div class="p-8 rounded-xl flex flex-col items-center text-center">
          <div
            class="w-24 h-24 mb-6 flex items-center justify-center rounded-full bg-accent-orange/10"
          >
            <img
              src="https://placehold.co/200x150/E67E22/FFFFFF?text=Feature+B+Icon"
              alt="Feature B Icon"
              class="rounded-lg w-full h-auto object-cover border border-border-color"
            />
          </div>
          <h3 class="text-2xl font-bold mb-3 text-primary">
            Emmergency & Alert System
          </h3>
          <p class="text-secondary opacity-80">
            Residents can trigger emergency alerts, instantly notifying security
            and managers. Alerts are logged and escalated if needed.
          </p>
        </div>
        <div class="p-8 rounded-xl flex flex-col items-center text-center">
          <div
            class="w-24 h-24 mb-6 flex items-center justify-center rounded-full bg-accent-green/10"
          >
            <img
              src="https://placehold.co/200x150/336799/FFFFFF?text=Feature+D+Icon"
              alt="Feature D Icon"
              class="rounded-lg w-full h-auto object-cover border border-border-color"
            />
          </div>
          <h3 class="text-2xl font-bold mb-3 text-primary">
            Smart Visitor Invitations
          </h3>
          <p class="text-secondary opacity-80">
            Equip your guards and admins with real-time alerts, patrol logs, and
            visitor verification tools.
          </p>
        </div>
        <div class="p-8 rounded-xl flex flex-col items-center text-center">
          <div
            class="w-24 h-24 mb-6 flex items-center justify-center rounded-full bg-accent-blue/10"
          >
            <img
              src="https://placehold.co/200x150/336799/FFFFFF?text=Feature+D+Icon"
              alt="Feature D Icon"
              class="rounded-lg w-full h-auto object-cover border border-border-color"
            />
          </div>
          <h3 class="text-2xl font-bold mb-3 text-primary">
            Real-time Access Logs
          </h3>
          <p class="text-secondary opacity-80">
            Every scan, alert, or visitor entry is time-stamped and visible to
            the manager dashboard for review.
          </p>
        </div>
      </div>
    </div>
  </section>
  <!-- Key Features Refatored ends -->

  <section class="py-20 lg:py-5 bg-secondary gradient-bg-section">
    <div class="container mx-auto px-6">
      <h2 class="text-4xl lg:text-5xl font-bold text-center mb-16 text-primary">
        How It Works: Streamlined Access
      </h2>
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-12">
        <div
          class="bg-card p-8 rounded-xl shadow-lg border border-border-color"
        >
          <h3 class="text-3xl font-bold mb-4 text-primary">
            Define Access Policies
          </h3>
          <p class="text-lg text-secondary opacity-90 mb-4">
            Manage who can enter, when, and why — in a few taps.
          </p>
          <ul class="list-disc list-inside space-y-2 text-primary text-lg">
            <li>Role-based permissions (Resident, Security, Manager)</li>
            <li>Time-bound visitor codes</li>
            <li>Emergency override rules</li>
            <li>Mobile-first user experience</li>
          </ul>
        </div>
        <div
          class="bg-card p-8 rounded-xl shadow-lg border border-border-color"
        >
          <h3 class="text-3xl font-bold mb-4 text-primary">
            Integrate with Estate Security
          </h3>
          <p class="text-lg text-secondary opacity-90 mb-4">
            Estate360 Community syncs across users and roles.
          </p>
          <ul class="list-disc list-inside space-y-2 text-primary text-lg">
            <li>QR scanner and code system for security officers</li>
            <li>
              Broadcast messaging API to connect to Estate360 Organization or
              CRM tools
            </li>
            <li>Reporting dashboard for managers and admins</li>
            <li>Optional webhook for syncing estate analytics</li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="py-20 lg:py-32 bg-primary">
    <div class="container mx-auto px-6">
      <h2 class="text-4xl lg:text-5xl font-bold text-center mb-16 text-primary">
        Resources
      </h2>
      <div class="grid grid-cols-1 lg:grid-cols-4 gap-8">
        <a
          href="#"
          class="block text-[#111] bg-card p-8 rounded-xl shadow-lg border border-border-color resource-card transition-all duration-300"
        >
          <h3 class="text-2xl font-bold mb-3 text-primary">
            Estate360 Community Setup Guide
          </h3>
          <p class="text-secondary opacity-80">
            Step-by-step on launching Community in your estate
          </p>
          <span class="text-accent-blue text-sm mt-4 inline-block text-[#111]"
            >Read More &rarr;</span
          >
        </a>
        <a
          href="#"
          class="block text-[#111] bg-card p-8 rounded-xl shadow-lg border border-border-color resource-card transition-all duration-300"
        >
          <h3 class="text-2xl font-bold mb-3 text-primary">
            Resident App User Manual
          </h3>
          <p class="text-secondary opacity-80">
            Full guide for residents: QR, alerts, service requests
          </p>
          <span class="text-accent-blue text-sm mt-4 inline-block text-[#111]"
            >Read More &rarr;</span
          >
        </a>
        <a
          href="#"
          class="block text-[#111] bg-card p-8 rounded-xl shadow-lg border border-border-color resource-card transition-all duration-300"
        >
          <h3 class="text-2xl font-bold mb-3 text-primary">
            Security Workflow Handbook
          </h3>
          <p class="text-secondary opacity-80">
            Digital tools and best practices for estate security
          </p>
          <span class="text-accent-blue text-sm mt-4 inline-block text-[#111]"
            >Read More &rarr;</span
          >
        </a>
        <a
          href="#"
          class="block text-[#111] bg-card p-8 rounded-xl shadow-lg border border-border-color resource-card transition-all duration-300"
        >
          <h3 class="text-2xl font-bold mb-3 text-primary">
            Manager Dashboard Overview
          </h3>
          <p class="text-secondary opacity-80">
            Manage visitors, services, and emergencies with ease
          </p>
          <span class="text-accent-blue text-sm mt-4 inline-block text-[#111]"
            >Read More &rarr;</span
          >
        </a>
      </div>
    </div>
  </section>

  <section class="py-20 lg:py-10 bg-accent-blue text-white">
    <div class="container mx-auto px-6 text-center">
      <h2 class="text-4xl lg:text-6xl font-extrabold leading-tight mb-8">
        Ready to Make Your Estate Smarter?
      </h2>
      <p class="text-lg lg:text-xl max-w-3xl mx-auto mb-12 opacity-90">
        Join forward-thinking communities adopting Estate360 Community to boost
        security, ease communication, and streamline estate operations.
      </p>
      <div
        class="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4"
      >
        <button
          class="btn-primary bg-white text-accent-blue px-10 py-4 rounded-full text-xl font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
        >
          Request a Demo
        </button>
        <button
          class="border-2 border-white text-white px-10 py-4 rounded-full text-xl font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 hover:bg-white hover:text-accent-blue"
        >
          View Documentation
        </button>
      </div>
    </div>
  </section>
</main>

<!-- Modal -->
<div
  *ngIf="showModal"
  class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
>
  <div
    class="bg-white w-full max-w-lg rounded-lg shadow-lg p-6 relative max-sm:mx-4"
  >
    <h2 *ngIf="!isSuccess" class="text-xl font-bold mb-4 text-[#111]">
      Register Estate
    </h2>
    <div
      *ngIf="errorMessage"
      class="w-full p-5 text-center bg-[#ffd1d1] rounded-md my-3"
    >
      <p class="text-[#fa3d3d] max-sm:text-[12px]">{{ errorMessage }}</p>
    </div>

    <form
      *ngIf="!isSuccess"
      [formGroup]="newEstateForm"
      (submit)="onSubmit()"
      class="overflow-y-scroll h-[400px] scrollbar-hide"
    >
      <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1">Email</label>
        <input
          type="email"
          class="w-full border rounded px-3 py-2"
          name="email"
          formControlName="email"
          required
        />
      </div>

      <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1"
          >First Name</label
        >
        <input
          type="text"
          class="w-full border rounded px-3 py-2"
          name="firstName"
          formControlName="firstName"
          required
        />
      </div>

      <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1"
          >Last Name</label
        >
        <input
          type="text"
          class="w-full border rounded px-3 py-2"
          name="lastName"
          formControlName="lastName"
          required
        />
      </div>

      <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1"
          >Estate Name</label
        >
        <input
          type="text"
          class="w-full border rounded px-3 py-2 text-[#111]"
          name="estateName"
          formControlName="estateName"
          required
        />
      </div>
      <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1"
          >Estate Location</label
        >
        <input
          type="text"
          class="w-full border rounded px-3 py-2 text-[#111]"
          name="estateLocation"
          formControlName="estateLocation"
          required
        />
      </div>

      <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1"
          >Applicant Category</label
        >
        <select
          class="w-full border rounded px-3 py-2 text-[#111]"
          name="applicantCategory"
          formControlName="applicantCategory"
          required
        >
          <option value="" disabled selected>Select a category</option>
          <option value="RESIDENT">Resident</option>
        </select>
      </div>

      <!-- <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1"
          >Applicant Category</label
        >
        <input
          type="text"
          class="w-full border rounded px-3 py-2 text-[#111]"
          name="applicantCategory"
          formControlName="applicantCategory"
          required
        />
      </div> -->

      <div class="mb-4">
        <label class="block text-[#111] text-sm font-medium mb-1"
          >Phone Number</label
        >
        <input
          type="tel"
          class="w-full border rounded px-3 py-2 text-[#111]"
          name="phoneNumber"
          formControlName="phoneNumber"
          required
        />
      </div>

      <div class="flex justify-end space-x-3">
        <button
          type="button"
          (click)="showModal = false"
          class="px-4 py-2 bg-[#111] rounded hover:bg-gray-400"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="px-4 py-2 bg-[#336799] text-white rounded hover:bg-[#79abda]"
        >
          <div
            *ngIf="isLoaded"
            class="inline-flex items-center text-white text-sm font-medium rounded-md opacity-70 cursor-not-allowed"
            type="button"
            disabled
          >
            <span
              class="animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2"
              aria-hidden="true"
            ></span>
            <span class="sr-only" role="status">Loading...</span>
          </div>

          <span *ngIf="!isLoaded">Register</span>
        </button>
      </div>
    </form>
    <div *ngIf="isSuccess">
      <div class="text-right">
        <button (click)="closeModal()" class="text-zinc-400 font-[600]">
          x
        </button>
      </div>
      <div
        class="container flex flex-col justify-center items-center text-center"
      >
        <img src="/assets/icons/success.png" alt="" />
        <h5 class="mt-2 text-[#111]">
          your estate registration request has been recieved, our team will
          contact you
        </h5>
      </div>
    </div>
  </div>
</div>
